import { version } from "../package.json";

import DCardPanel from './components/DCardPanel.vue'
import DCard from './components/DCard/DCard.vue'
import DCardInfo from './components/DCardInfo/DCardInfo.vue'
import DCompareTable from './components/DCompareTable/DCompareTable.vue'

//libs
import Logger from './libs/logger.js'

export { version, DCardPanel, DCard, DCardInfo, Logger };

export default {
  version,

  DCardPanel,
  DCard,
  DCardInfo,
  DCompareTable,
  Logger,

  install(Vue) {
    window.DCardPanel = DCardPanel
    window.DCard = DCard
    window.DCardInfo = DCardInfo
    Vue.component(DCardPanel.name, DCardPanel);
    Vue.component(DCard.name, DCard);
    Vue.component(DCardInfo.name, DCardInfo)
    Vue.component(DCompareTable.name, DCompareTable);
  },
};
